module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.073dba1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey/font/notokr-bold.woff2
// module id = DRF+
// module chunks = 0